import {
  businessCenterIconv1,
  commandCenterIcon,
  keapMaxIcon,
  marketingCenterIconv1,
  reportingCenterIconv1,
  workforceCenterIconv1,
} from '../../../../assets'

export const dataJSON = {}

export const VALIDITY_IN_HOUR_IN_MS = 3601000

export const NON_ADDED_PLANS = [
  'addon-5-signatures_usage',
  'app-websitebuilder',
  'cc_basicpls-5-thryv-m2m',
  'thryvprfee',
]

export const PAYMENT_METHODS = [
  {name: 'Card', value: 'card', icon: 'creditCard'},
  {name: 'Bank Transfer with ACH', value: 'ach', icon: 'landmark'},
]

export const AUS_PAYMENT_METHODS = [
  {name: 'Card', value: 'card', icon: 'creditCard'},
  {name: 'BECS', value: 'becs', icon: 'landmark'},
]

export const COUNTRIES = [
  {name: 'United States', value: 'US'},
  {name: 'Australia', value: 'AU'},
  {name: 'Cayman Islands', value: 'KY'},
  {name: 'Barbados', value: 'BB'},
  {name: 'Canada', value: 'CA'},
  {name: 'New Zealand', value: 'NZ'},
]

export const REACT_APP_OOE_SERVICE_URL = process.env.REACT_APP_OOE_SERVICE_URL
export const ONE_TIME_FEES = [
  '5 extra website pages',
  'professional designed logo',
  'onboarding fee',
  'website design fee',
  'custom video shoot',
  'thryv ignite implementation',
  'advanced crm data import',
  'advanced data transfer',
  'ask the expert',
  'basic crm data import',
  'credit card import',
  'data restore',
  'e-commerce data import',
  'e-commerce data transfer',
  'hourly data service',
  'limited e-commerce crm import',
  'custom done for you',
  'thryv vertical services',
  'thryv vertical and mc services & design',
  'thryv vertical and mc services',
  'vertical and mc services & design',
  'vertical and mc services',
  'vertical services',
]

export const INITIAL_PAYMENT_STATE = {
  paymentMethod: PAYMENT_METHODS[0],
  paymentInfo: undefined,
  calculatedTaxes: null,
  totalPaymentAmount: 0,
  totalPaymentAmountNoTaxes: 0,
  semiAnnuallyAmount: 0,
  monthlyAmount: 0,
  oneTimeAmount: 0,
  monthlyAddons: [],
  semiAnnuallyAddons: [],
  oneTimeAddons: [],
  taxes: {
    monthly: null,
    semiAnnually: null,
    oneTime: null,
  },
}

export const PLANS_ICONS = [
  {
    name: 'my account',
    icon: commandCenterIcon,
  },
  {
    name: 'business center',
    icon: businessCenterIconv1,
  },
  {
    name: 'marketing center',
    icon: marketingCenterIconv1,
  },
  {
    name: 'reporting center',
    icon: reportingCenterIconv1,
  },
  {
    name: 'workforce center',
    icon: workforceCenterIconv1,
  },
  {
    name: 'keap max',
    icon: keapMaxIcon,
  },
]
